import {_} from '../globals';
    angular.module('mySynch').service('IndexedDBFactory',class IndexedDBFactory { 
        
        callbackOrLog:any;
        userCookieCheckInterval:any;
        objectDataAll:any = {
            'activitySubType': [],
            'activityType': [],
            'breedName': [],
            'diagnosisType': [],
            'farmType': [],
            'eventType': [],
            'fertilityProgramDefinedSequence': [],
            'fertilityProgramPregnancyCheckFrequencyType': [],
            'fertilityProgramType': [],
            'fertilityProgramFrequencyType': [],
            'herdAvailableEventType': [],
            'herdSoftwareType' : [],
            'identificationType' : [],
            'itemType' : [],
            'journalCategory' : [],
            'missingRuleType' : [],
            'measurementType' : [],
            'reportLineItem' : [],
            'reproductiveProtocolAlternativeType' : [],
            'reproductiveProtocolRule' : [],
            'personType' : [],
            'productType' : [],
            'selectionConstraintType' : [],
            'roleType' : [],
            'reproductiveProtocolSequence' : [],
            'stateType' : [],
            'timeConstraintType' : [],
            'statusType' : [],
            'unitType' : [],
            'uploadStatusType' : [],
            'weekdayType' : []
        };	
        static $inject = ['ApiBase','$timeout'];
		constructor(apiBase, $timeout) {
          this.callbackOrLog  = apiBase.callbackOrLog;
        }
           
           
            
            openObjectStore(DbName){
                var request = indexedDB.open(DbName);
                return request;
            };
            createObjectStore(DbName, data) {
                var request = indexedDB.open(DbName);
                request.onupgradeneeded = (event) => {
                    var db = _.get(event,'target.result') as IDBDatabase;
                    if (data.keyId != '') {
                        var store = db.createObjectStore(data.tableName, {keyPath: data.keyId});
                        store.createIndex(`${data.tableName}_${data.keyId}_unqiue`, data.keyId, {unique: true});
                    }
                };
            };

           createObjectStores(DbName, data) {
                var request = indexedDB.open(DbName);
                request.onupgradeneeded = (event) => {
                    var db = _.get(event,'target.result') as IDBDatabase;
                    data.forEach((item) => {
                        if (item.keyId != '') {
                            var store = db.createObjectStore(item.tableName, {keyPath: item.keyId});
                            store.createIndex(`${item.tableName}_${item.keyId}_unqiue`, item.keyId, {unique: true});
                        }
                    });
                };
            };

            writeData(DbName, data,callback = function(){}) {
                var request = indexedDB.open(DbName);
                request.onsuccess = (event) => {
                  try{   
                    if (data.keyId != '') {
                        var tableData = data.data;
                        var db = _.get(event,'target.result') as IDBDatabase;
                        var transaction = db.transaction(data.tableName, 'readwrite');
                        var dataStore = transaction.objectStore(data.tableName);
                        dataStore.clear();
                        tableData.forEach((row)=>{
                            dataStore.add(row);
                        });
                        
                    }
                    this.callbackOrLog(callback, null, null);
                }catch(e){
                    this.callbackOrLog(callback,_.get(e,'message',"error in indexeddb service writeData"),[]);
                }  
                };
            };

            writeDatas(DbName, data, callback = function(){}) {
                var request = indexedDB.open(DbName);
                request.onsuccess = (event) => {
                  try{   
                        data.forEach((item) => {
                            if (item.keyId != '') {
                                var tableData = item.data;
                                var db = _.get(event,'target.result') as IDBDatabase;
                                var transaction = db.transaction(item.tableName, 'readwrite');
                                var dataStore = transaction.objectStore(item.tableName);
                                dataStore.clear();
                                tableData.forEach((row) =>{
                                    dataStore.add(row);
                                });
                            }
                        });
                        this.callbackOrLog(callback, null, null);
                  }catch(e){
                    this.callbackOrLog(callback,_.get(e,'message',"error in indexeddb service writeDatas"),[]);
                  }
                };
            };

            readData(DbName, tableName, callback) {
                var request = indexedDB.open(DbName);
                request.onsuccess = (event) => {
                  try{  
                        var db = _.get(event,'target.result') as IDBDatabase;
                        var transaction = db.transaction(tableName, 'readonly');
                        var dataStore = transaction.objectStore(tableName);
                        var req = dataStore.getAll();
                        var data;
                        req.onsuccess = (event) => {
                            if (req.result) {
                                data = req.result;
                            }
                            this.callbackOrLog(callback, null, data);
                        };
                  }catch(e){
                    this.callbackOrLog(callback,_.get(e,'message',"error in indexeddb service readData"),[]);
                  }
                };
            };

            readDatas(DbName, listNames, callback) {
                var request = indexedDB.open(DbName);
                request.onsuccess = (event) => {
                  try{    
                        listNames.forEach((item) => {
                            var db = _.get(event,'target.result') as IDBDatabase;
                            var transaction = db.transaction(item.name, 'readonly');
                            var dataStore = transaction.objectStore(item.name);
                            var req = dataStore.getAll();
                            req.onsuccess = (event) => {
                                if (req.result) {
                                    this.objectDataAll[item.name] = req.result;
                                } 
                            };
                        });
                       this.userCookieCheckInterval = setInterval(() =>{  
                            this.callbackOrLog(callback, null, this.objectDataAll || null);
                        },300);

                  }catch(e){
                    this.callbackOrLog(callback,_.get(e,'message',"error in indexeddb service readDatas"),[]);
                  }
                };
            };

            

           
        	
	});
